import React, { createContext, useContext, useState, useEffect } from 'react';
import { getData } from '../Webservice/Webservice';

const CartContext = createContext();

export const CartProvider = ({ children }) => {
  const [cartCount, setCartCount] = useState(0);

  const fetchCartCount = async () => {
    try {
      const token = sessionStorage.getItem("token");
      if (!token) {
        setCartCount(0);
        return;
      }
      
      const response = await getData('cart/get-cart', {}, `Bearer ${token}`);
      if (response?.cartData?.items) {
        const totalItems = response.cartData.items.reduce((sum, item) => sum + (item.quantity || 1), 0);
        setCartCount(totalItems);
      } else {
        setCartCount(0);
      }
    } catch (error) {
      console.error("Error fetching cart count:", error);
      setCartCount(0);
    }
  };

  // Initial fetch
  useEffect(() => {
    fetchCartCount();
  }, []);

  const updateCartCount = (newCount) => {
    setCartCount(newCount);
  };

  return (
    <CartContext.Provider value={{ cartCount, updateCartCount, fetchCartCount }}>
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => {
  const context = useContext(CartContext);
  if (!context) {
    throw new Error('useCart must be used within a CartProvider');
  }
  return context;
};
